module.exports = __webpack_public_path__ + "img/album14_15.8fef2d39.jpg";